@import '~style-sheet-helpers/core.less';

.delete-product-modal-body {
  padding: 15px;
  font-size: 13px;
  line-height: 1.3;
}
